const PieChart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.1001 0.600098C9.08501 0.600098 10.0603 0.794091 10.9702 1.171C11.8802 1.54791 12.707 2.10036 13.4034 2.7968C14.0998 3.49324 14.6523 4.32003 15.0292 5.22998C15.4061 6.13992 15.6001 7.11519 15.6001 8.1001M8.1001 0.600098V8.1001M8.1001 0.600098C3.95796 0.600098 0.600098 3.95796 0.600098 8.1001C0.600098 12.2422 3.95796 15.6001 8.1001 15.6001C12.2422 15.6001 15.6001 12.2422 15.6001 8.1001M8.1001 0.600098C12.2422 0.600098 15.6001 3.95797 15.6001 8.1001M15.6001 8.1001L8.1001 8.1001M15.6001 8.1001C15.6001 9.28368 15.32 10.4505 14.7826 11.505C14.2453 12.5596 13.466 13.472 12.5085 14.1677L8.1001 8.1001"
      stroke="#6D28D9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PieChart;
